import React, { useCallback } from "react";
import ReactMarkdown from "react-markdown";
import remarkEmoji from "remark-emoji";
import rehypeRaw from "rehype-raw";

function HtmlSetting({ setting }) {
  const customAnchorTag = useCallback(
    ({ href, children, ...props }) => (
      <a
        href={href}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {children}
      </a>
    ),
    []
  );

  return (
    <ReactMarkdown
      remarkPlugins={[remarkEmoji]}
      rehypePlugins={[rehypeRaw]}
      components={{
        a: customAnchorTag,
      }}
    >
      {setting.en_field_label || ""}
    </ReactMarkdown>
  );
}

export default HtmlSetting;
